import React, { useState } from 'react';
import { JsonLd } from 'react-schemaorg';
import { browserHistory } from 'react-router';
import map from 'lodash/map';
import get from 'lodash/get';
import includes from 'lodash/includes';
import findIndex from 'lodash/findIndex';
// import split from 'lodash/split';
// import sortBy from 'lodash/sortBy';
// import forEach from 'lodash/forEach';
// import beautifyNumber from 'helpers/beautifyNumber';
// import formatDate from 'helpers/formatDate';
// import numDesc, { numDescOnlyText } from 'helpers/numDesc';
import absoluteUrl from 'helpers/absoluteUrl';
import urlShortener from 'helpers/urlShortener';
import { Input } from 'containers/form';
import Icon, { iconTypes } from 'components/icon';
import Link from 'components/link';
import Button from 'components/button';
import { Thumb } from 'components/image';
import Row, { Col } from 'components/row';
import DropDown from 'components/drop-down';

import linksDomik from 'src-sites/domik/links';

import StockCardNews from './stock-card-news';

function renderLink(
  bemClasses, data,
  urlBuilder, text = '', external = false, builderProps = {}, dataProps = {}, textBefore = null
) {
  const linkProps = { builder: urlBuilder };
  let linkText = <span />;

  if (external) {
    linkProps.builder = null;
    linkProps.href = urlBuilder;
    linkProps.title = builderProps.title || null;
    linkProps.dataProps = { dataProps };
    linkText = (
      <span {...bemClasses('linkContent')}>
        {textBefore}
        <span {...bemClasses('text')} children={urlShortener(text)} />
      </span>
    );
  } else if (text) {
    linkProps.builder = urlBuilder;
    linkText = (
      <span {...bemClasses('linkContent')}>
        {textBefore}
        <span {...bemClasses('text')} children={text} />
      </span>
    );
  }

  return (
    <Link
      {...bemClasses('link', { fill: !text })}
      {...linkProps}
      builderProps={{
        ...data,
        developer: data.url,
        title: data.name_short,
        ...builderProps
      }}
      external={external}
      dataProps={dataProps}
    >
      {linkText}
    </Link>
  );
}

// рендер Лого Застройщика
function renderLogoDeveloper(bemClasses, data) {
  const { avatar, name } = data;
  const image = typeof avatar === 'string' ? { id: avatar } : avatar;
  const avatarDeveloper = { ...image, alt: name, title: name };

  return (
    <>
      <Thumb
        {...bemClasses('imgPic')}
        image={avatarDeveloper}
      />
      <JsonLd
        item={{
          '@context': 'https://schema.org',
          '@type': 'ImageObject',
          name: get(avatarDeveloper, 'alt', null),
          description: get(avatarDeveloper, 'title', null),
          contentUrl: get(image, 'id') ? absoluteUrl(`/images/thumb/full/${image.id}`) : null
        }}
      />
    </>
  );
}

// рендер Лого ЖКшки
function renderLogoLC(bemClasses, data) {
  const { display_name: name } = data;
  const avatar = get(data, 'images.others[0].image');
  const image = typeof avatar === 'string' ? { id: avatar } : avatar;
  const avatarLC = { ...image, alt: name, title: name };

  return (
    <>
      <Thumb
        {...bemClasses('imgPic')}
        image={avatarLC}
      />
      <JsonLd
        item={{
          '@context': 'https://schema.org',
          '@type': 'ImageObject',
          name: get(avatarLC, 'alt', null),
          description: get(avatarLC, 'title', null),
          contentUrl: get(image, 'id') ? absoluteUrl(`/images/thumb/full/${image.id}`) : null
        }}
      />
    </>
  );
}

// рендер Застройщика
export function renderDevelopers(classes, list) {
  if (!list || !list.length) return null;

  const { i18n } = this;
  const developersList = list.slice(0, 1);

  return map(developersList, (item, key) => (
    <Row {...classes('row', 'developer')} key={key}>
      <Col {...classes('col', 'img')} allAuto allFlex allColumn allPr={0}>
        <div {...classes('imgContainer')}>
          <div {...classes('img')}>
            {item.website && renderLink.call(
              this,
              classes,
              item,
              item.website,
              '',
              true,
              { title: i18n('developerLinkToSiteTitle') },
              { 'data-gtm-dev': item.name }
            )}
            {renderLogoDeveloper(classes, item)}
          </div>
        </div>
      </Col>
      <Col {...classes('col', 'info')} allAuto allFlex allColumn allPr={0}>
        {item.name &&
          <div {...classes('item', 'link topic')}>
            {renderLink(
              classes,
              item,
              linksDomik.sectionLanding,
              item.name,
              false,
              { title: item.name, url: item.url }
            )}
          </div>
        }
        {item.website &&
          <div {...classes('item', 'link website')}>
            {renderLink.call(
              this,
              classes,
              item,
              item.website,
              item.website,
              true,
              { title: i18n('developerLinkToSiteTitle') },
              { 'data-gtm-dev': item.name }
            )}
          </div>
        }
      </Col>
    </Row>
  ));
}

// рендер ЖКшек
export function renderLC(classes, list) {
  if (!list || !list.length) return null;

  const { i18n } = this;
  const LCList = list.slice(0, 1);

  return map(LCList, (item, key) => {
    const complexSites = get(item, 'complex_sites[0]');
    const { display_name, url } = item;

    return (
      <Row {...classes('row', 'developer lc')} key={key}>
        <Col {...classes('col', 'img')} allAuto allFlex allColumn allPr={0}>
          <div {...classes('imgContainer')}>
            <div {...classes('img')}>
              {complexSites && renderLink.call(
                this,
                classes,
                item,
                complexSites,
                '',
                true,
                { title: i18n('developerLinkToSiteTitle') },
                { 'data-gtm-dev': display_name }
              )}
              {renderLogoLC(classes, item)}
            </div>
          </div>
        </Col>
        <Col {...classes('col', 'info')} allAuto allFlex allColumn allPr={0}>
          {display_name &&
            <div {...classes('item', 'link topic')}>
              {renderLink(
                classes,
                item,
                linksDomik.sectionLanding,
                display_name,
                false,
                { title: display_name, url }
              )}
            </div>
          }
          {complexSites &&
            <div {...classes('item', 'link website')}>
              {renderLink.call(
                this,
                classes,
                item,
                complexSites,
                complexSites,
                true,
                { title: i18n('developerLinkToSiteTitle') },
                { 'data-gtm-dev': display_name }
              )}
            </div>
          }
        </Col>
      </Row>
    );
  });
}

// рендер Мнения
export function renderOpinion(classes, data) {
  if (!get(data, 'properties.expertOpinion')) return null;

  const { i18n } = this;

  return (
    <Row {...classes('row', 'opinion')}>
      <Col {...classes('col', 'opinion')} allAuto allFlex allColumn allPr={0}>
        <div {...classes('item', 'opinion')}>
          <span {...classes('text')} children={i18n('expertOpinion')} />
        </div>
      </Col>
    </Row>
  );
}

// рендер кнопки Назад
export function renderToBack(classes, mounted) {
  const { i18n } = this;

  return (
    <div {...classes()}>
      <Row {...classes('row')}>
        <Col {...classes('col')} allFlex allColumn allPr={0}>
          {/*
          mounted &&
          browserHistory &&
          browserHistory.goBack &&
          window.history.length > 1 &&
            <Button
              {...classes('btn', 'toBack')}
              onClick={browserHistory.goBack}
              label={i18n('toBack')}
              title={i18n('toBack')}
              iconType={iconTypes.arrowSliderLeft}
            />
          */}
        </Col>
      </Row>
    </div>
  );
}

export function renderStocksList() {
  // const { i18n } = this;
  const nbStocksList = get(this, 'props.nbStocksList.data', []);
  if (!nbStocksList.length) return null;

  return (
    <>
      {map(nbStocksList, (stock, key) => {
        return (
          <StockCardNews key={key} object={stock} />
        );
      })}
    </>
  );
}

// рендер списка Рубрик
export function renderRubricsList(classes) {
  const { i18n } = this;
  const currentRubrics = get(this, 'props.publication.data[0].rubrics_ids');
  const currentLandingId = get(this, 'props.params.landing.entity_id');
  const allRubrics = get(this, 'props.rubricTree.data');

  const rubricList = (
    <ul {...classes(null, 'main')}>
      {map(allRubrics, (item, key) => {
        const active = currentRubrics ?
          includes(currentRubrics, item.id) :
          findIndex(item.children, child => child.id === currentLandingId) > -1;

        return (
          <li
            {...classes('item')}
            key={key}
          >
            <Link
              {...classes('link', { main: true, active })}
              builder={linksDomik.sectionLanding}
              builderProps={{ title: item.name, url: item.url }}
            >
              <span {...classes('linkContent')}>
                <span {...classes('text')} children={item.name} />
              </span>
            </Link>
          </li>
        );
      })}
    </ul>
  );

  if (!this.state.mounted) {
    return (
      <>
        <div {...classes('dropdown', 'noJs', 'dropdown')} />
        {rubricList}
      </>
    );
  }

  if (this.state.device === 'desktop') return rubricList;

  return (
    <DropDown
      {...classes('dropdown')}
      modalHeader={i18n('rubrics')}
      ref={el => this.ddRef = el}
    >
      <Button
        {...classes('btn', 'dropdown')}
        iconSecondType={iconTypes.carretBild}
        label={i18n('rubrics')}
        inForm
        // TODO: Дима, тут должен отрабатывать клик на "Все" (но это не точно)
      />
      <div children={rubricList} />
    </DropDown>
  );
}

// рендер списка Рубрик в Новосте
export function renderCurrentRubrics(classes, rubrics) {
  // const { i18n } = this;
  return (
    <>
      {map(rubrics, (rubr, key) => {
        return (
          <div key={key} {...classes('rubric')}>
            <Link
              {...classes('link', 'toRubric')}
              builder={linksDomik.sectionLanding}
              builderProps={rubr}
            >
              <span {...classes('linkContent')}>
                <span {...classes('text')} children={rubr.name} />
              </span>
            </Link>
          </div>
        );
      })}
    </>
  );
}

// Поисковик в Новостях
export function SearchInput(props = {}) {
  const { onSearch, i18n, classes, className } = props;
  const [ value, setValue ] = useState(props.value || null);

  return (
    <div {...classes({ extra: className })}>
      <form
        {...classes('form')}
        onSubmit={(e) => {
          e.preventDefault();
          if (value) {
            onSearch(value);
          }
        }}
      >
        <Input
          {...classes('input')}
          value={value}
          onChange={val => setValue(val)}
          schema={{
            placeholder: i18n('searchPlaceholder')
          }}
          noLabel
          noError
        />
        <Button
          {...classes('btn', 'search')}
          type="submit"
          title={i18n('searchBtnTitle')}
          iconType={iconTypes.searchBild}
        />
      </form>
    </div>
  );
}
